<template>
  <div>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getAll"
      :employeeId="employeeId"
    ></Create>

    <v-container>
      <v-card outlined>
        <v-card-title class="pb-2">
          <v-icon left>mdi-paperclip</v-icon>
          Attachments
          <v-chip small class="ml-3" color="primary">{{ count }}</v-chip>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mb-2" @click="createAttachment">
            <v-icon left>mdi-plus</v-icon>
            New Attachment
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear v-if="loading" indeterminate class="mb-0"></v-progress-linear>

        <v-list two-line class="py-0" v-else-if="attachments.length > 0">
          <template v-for="(item, index) in attachments">
            <v-list-item :key="item.id">
              <v-list-item-avatar size="100" tile @click="openView(item)">
                <v-img :src="item.url"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-capitalize font-weight-medium">{{ item.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-menu offset-y bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click.stop.prevent="deleteAttachment(item)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="index < attachments.length - 1" :key="'divider-' + item.id"></v-divider>
          </template>
        </v-list>

        <div v-else class="text-center grey--text py-8">
          No attachments found.
        </div>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog" max-width="90%">
      <v-card v-if="selectedAttachment">
        <v-toolbar dense class="mb-3" flat color="grey lighten-3">
          <v-toolbar-title class="subtitle-1">
            {{ selectedAttachment.createdAt | moment("MM/DD/YYYY hh:mm A") }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="imageViewBox">
          <v-img :src="selectedAttachment.url" />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import attachmentService from "../service";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "attachment-list",
  props: {
    employeeId: {
      default: null
    },
  },
  data() {
    return {
      attachments: [],
      createDialog: false,
      count: 0,
      limit: 50,
      selectedAttachment: null,
      dialog: false,
      offset: 0,
      loading: false,
      pagination: {
        sortBy: "name",
      },
    };
  },
  async created() {
    this.getAll();
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    openView(attachment) {
      this.selectedAttachment = attachment
      this.dialog = !this.dialog
    },
    createAttachment() {
      this.createDialog = !this.createDialog;
    },
    getAll() {
      this.loading = true;
      return attachmentService
        .getAll({
          limit: this.limit,
          offset: this.offset,
          noPagination: true,
          orderBy: [this.pagination.sortBy],
          EmployeeId: this.employeeId
        })
        .then(async (response) => {
          this.attachments = response.data.sort((a, b) => a.name.localeCompare(b.name));
          this.count = response.count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    deleteAttachment(attachment) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            attachmentService.delete(attachment.id).then((response) => {
              if (response.data) {
                this.$toast.success("Attachment has been deleted", {
                  timeout: 2000,
                });

              this.getAll();
              }
            });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
  },
};
</script>

<style scoped>
.imageViewBox {
  height: 500px;
  overflow: auto;
}
</style>